// src/packages/viriyah/non-motor/viriyah_cargo_inland_020/index.js
import CargoInlandCard from "./CargoInlandCard";
import CargoInlandDetails from "./CargoInlandDetails";
import "./cargo_inland.css";

export default {
  id: "viriyah_cargo_inland_020",
  company: "วิริยะประกันภัย",
  productLine: "non-motor",
  categories: ["cargo", "inland", "marine"],
  nameTH: "Inland Transit (020) — ขนส่งภายในประเทศ",
  description:
    "คุ้มครองสินค้าระหว่างขนส่งในประเทศ ทางบก/เรือ/รถไฟ/เครื่องบิน เลือกแบบคุ้มครองได้ (ระบุภัย/เสี่ยงภัยทุกชนิด)",
  accent: "#004aad",
  expiresAt: "9999-12-31",
  card: CargoInlandCard,
  detail: CargoInlandDetails,
  active: true
};
